<template lang="html">


	<article class="grid-el row-center ais" :selected="data.idPractica == $route.params.id">
	<router-link v-if="!!data.idPractica" class="enlace-cover" :to="linkBack+data.idPractica"></router-link>
		<router-link v-if="!!data.urlAcceso" class="enlace-cover" :to="linkBack+data.urlAcceso"></router-link>

		<figure class="indicador-status" :status="data.idEstadoValidacion" :title="data.estadoValidacion"></figure>
		
		<template v-for="(encabezado,key) in encabezados">	
			
			<div class="dato row-start" v-if="!!data[key]" :type="key">
				
				<h4 class="data-title">{{encabezado.nombre}}: <span>{{data[key]}}</span></h4>
				
			</div>
		</template>

		<fav :data="data"></fav>

	</article>


</template>

<script lang="js">

	import {mapGetters,mapActions} from 'vuex';

	import fav  from '@/components/parts/fav';

	export default  {
		name: 'grid-responsive-el',
		props: ['data'],
		computed :{
			encabezados : function(){
				//el historico comparte columnas con su listado (igual que en contenedor-tabla)
				let pagina = this.$route.name.replace("-historico", "");
				return this.getEncabezados[pagina] || {};
			},
			...mapGetters({
				styles : 'getStyles',
				colors : 'basicColors',
				favoritos : 'getFavoritos',
				getEncabezados : 'getEncabezados',
				textos : 'getTexts',
				lang : 'getLanguage'
			}),
			linkBack : function(){
				let estado = this.textos.enlaces[this.data.idEstadoValidacion];
				return `${this.$route.meta.indexPath[this.lang]}/${(!!this.$route.params.status) ? this.$route.params.status : estado }/`;
			},
		},
		components :{
			'fav' : fav,
		}
	}
</script>

<style scoped lang="scss">
	.grid-el {
		width: 100%;
		text-align: left;
		margin-bottom: 0px;
		max-width: 100%;
		padding: 10px 0px;
		position: relative;
		padding-left:70px;

		&[selected=selected]{
			background: rgba(51, 116, 176, 0.2);
		}
	}

	.grid-el .fav{
		position: absolute;
		left: 25px;
		top: 50%;
		margin-top: -12.5px;
		z-index: 7;
	}

	.indicador-status{
		position: absolute;
		left: 5px;
		top: 50%;
		margin-top: -6px;
	}

	.dato{
		display: none;
		width: 100%;
		margin-bottom: 10px;
		&:last-of-type{
			margin-bottom: 0;
		}
	}

	.dato[type="nombreEstudiante"],
	.dato[type="puesto"]{
		display: -webkit-flex;
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
	}

	.dato[type="puesto"]{
		margin-bottom: 0;
	}

	.data-title{

	}
	
	.data-title span{
		font-weight: 300;
	}

	.grid-el:nth-child(2n) {
		background: rgba(51, 116, 176, 0.05);
			&[selected=selected]{
			background: rgba(51, 116, 176, 0.2);
		}
	}

	@media screen and (max-width: 600px){
		.grid-el{
			max-width: 100%;
			margin-right: 0;
			padding-left: 40px;
		}

		.dato{
			width: 100%;
			padding-right: 0;
			margin-bottom: 5px;
		}

		.data-title span{
			width: 100%;
			display: inline-block;
		}

		.grid-el .fav{
			left: 5px;
			margin-left: 0;		
		}	

		.indicador-status{
			display: none;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/parts/grid-responsive-el.vue